module.exports = __webpack_public_path__ + "static/img/tips.62d9339.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tips.png
// module id = M3wb
// module chunks = 1